<template>
  <div class="page-container" >
    <md-app style="min-height: 100vh;">
      <md-app-toolbar class="md-primary">
          <span class="md-title">Informations sur ma société</span>
      </md-app-toolbar>

      <md-app-drawer md-permanent="full">
          <md-toolbar class="md-subheading" md-elevation="0">
          Mes informations
          </md-toolbar>

          <md-list>
          <md-list-item to="/FormSociete">
              <span class="md-list-item-text">Société</span>
          </md-list-item>

          <md-list-item to="/FormClients">
              <span class="md-list-item-text">Clients</span>
          </md-list-item>

          <md-list-item to="/FormProduits">
              <span class="md-list-item-text">Produits</span>
          </md-list-item>
          </md-list>

          <md-button class="md-raised md-primary" to="/FormFacture">Nouvelle facture</md-button>

      </md-app-drawer>
      <md-app-content>
        <router-view></router-view>
      </md-app-content>
    </md-app>
  </div>
</template>

<style lang="scss">
@import "~vue-material/dist/theme/engine"; // Import the theme engine

@include md-register-theme("default", (
  primary: #3b3e79, // The primary color of your brand
  accent: #f2784b // The secondary color of your brand
));

@import "~vue-material/dist/theme/all"; // Apply the theme
  .md-app {
    height: 100%;
    border: 1px solid rgba(#000, .12);
  }

   // Demo purposes only
  .md-drawer {
    width: 230px;
    max-width: calc(100vw - 125px);
  }

  .md-raised.md-primary {
    position: fixed;
    width: 92%;
    height: 50px;
    bottom: 75px;
    left: 0;
  }

  .md-list {
    width: 320px;
    max-width: 100%;
    display: inline-block;
    vertical-align: top;
    margin-top: 40px;
    padding-bottom: 0;
    border-top: 1px solid rgba(#000, .12);

  }

  .md-list-item {
    border-bottom: 1px solid rgba(#000, .12);
  }

</style>

<script>

export default {
  name: 'App',

}
</script>

